<nav class="navbar navbar-expand-lg  navbar-light bg-light fixed-top" *ngIf="tokenStorageService.getToken()">
    <div class="container-fluid ">
        <a class="navbar-brand" >Kompar</a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
            <ul class="navbar-nav mr-auto mb-2 mb-lg-0">
                <li class="nav-item mr-2 mb-1">
                    <button type="button" class="btn btn-light btn-sm" [routerLink]="'/accueil'">BDD</button>
                </li>
                <li class="nav-item">
                    <button type="button" class="btn btn-light btn-sm"  [routerLink]="'/blackliste'">Black liste</button>
                </li>

                <li class="nav-item">
                    <button type="button" class="btn btn-light btn-sm" *ngIf="tokenStorageService.getRole() =='ROLE_ADMIN'" [routerLink]="'/provisoire'">Provisoire</button>
                </li>
                <li class="nav-item mr-5 mb-1">
                    <button type="button" class="btn btn-warning btn-sm" (click)="logout()">Se déconnecter</button>
                </li>
            </ul>

        </div>
        
    </div>
</nav>
<hr class="mt-3 mb-3">
<router-outlet></router-outlet>